import axios from 'axios';
import {
  MapRenderRequest,
  MapRenderResponse,
} from '@shared/models/design/map-render.model';
import type {
  PdfGeometryImportAi,
  PdfGeometryImportResponse,
} from '@shared/models/design/pdf-geometry-import.model';

export const requestPhotorealisticRender = async (
  payload: MapRenderRequest,
): Promise<MapRenderResponse> => {
  const { data } = await axios.post<MapRenderResponse>(
    '/design-ai/renderings',
    payload,
  );
  return data;
};

/**
 * Upload a plan file and ask AI to extract footprint geometry + building height.
 * Optional extra instructions are appended last. Optional system prompt replaces
 * the default drawing-reading prompt.
 */
export const requestPdfGeometryImport = async (input: {
  file: File;
  ai: PdfGeometryImportAi;
  /** Optional instructions passed to the AI (e.g. scale hint, building selection). */
  extraInstructions?: string;
  /** Admin-edited drawing-reading prompt. Server falls back to the default when omitted. */
  systemPrompt?: string;
}): Promise<PdfGeometryImportResponse> => {
  const form = new FormData();
  form.append('pdf', input.file, input.file.name);
  form.append('provider', input.ai.provider);
  form.append('model', input.ai.model);
  if (
    input.ai.provider === 'openai' &&
    input.ai.reasoningEffort !== undefined
  ) {
    form.append('reasoningEffort', input.ai.reasoningEffort);
  }
  if (input.extraInstructions?.trim()) {
    form.append('extraInstructions', input.extraInstructions.trim());
  }
  if (input.systemPrompt?.trim()) {
    form.append('systemPrompt', input.systemPrompt.trim());
  }

  const { data } = await axios.post<PdfGeometryImportResponse>(
    '/design-ai/geometry-import',
    form,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  );
  return data;
};
